import { fonts } from '../../theme';

const badge = {
  display: 'inline-flex',
  alignItems: 'center',
  flexShrink: 0,
  m: 0,
  border: '1px solid',
  borderRadius: '999px',
  fontFamily: fonts.text,
  fontWeight: 700,
  letterSpacing: '0.06em',
  textTransform: 'uppercase',
  whiteSpace: 'nowrap',
};

// The color, its border (45%) and its background (14%) are set by the rank.
const styles = {
  // About 17px high, like the badge of the app: discreet next to a username.
  small: {
    ...badge,
    px: '6px',
    py: '1px',
    fontSize: 9.5,
    lineHeight: '13px',
    letterSpacing: '0.04em',
  },
  // Next to the username of a profile.
  medium: {
    ...badge,
    px: '9px',
    py: '3px',
    fontSize: 11.5,
    lineHeight: '16px',
  },
  clickable: {
    cursor: 'pointer',
    transition: 'opacity 0.15s',
    '&:hover': {
      opacity: 0.8,
    },
  },
};

export default styles;
